import React, { useState, useEffect, useRef } from 'react'
import './CompanyDetailPage.css'
import httpClient from '../components/helpers/httpClient'
import { useNavigate, useParams } from "react-router-dom"
import MenuBar from "../components/MenuBar"
import Header from "../components/Header"
import LoadingSpinner from "../components/placeholders/LoadingSpinner"
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace'
import Dropdown from '../components/Dropdown'
import CheckBox from '../components/CheckBox'
import DropdownMultiselectTags from '../components/DropdownMultiselectTags'
import { DateField } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { toast } from "react-toastify"
import Note from '../components/Note'
import { PopupWindow, closePopupWindow } from '../components/PopupWindow'
import { formatDate, parseDateValue } from '../components/helpers/formatDate'
import { PopOutWindow } from '../components/PopOutWindow'
import { noteTypes } from '../assets/data/data'
import AddContactToCompany from '../components/AddContactToCompany'
import DropdownSpecialObject from '../components/DropdownSpecialObject'
import DropdownMultiselect from '../components/DropdownMultiselect'
import { showNotificationPopup } from '../components/NotificationPopup'
import { getNoteCreatorName } from '../components/helpers/getNoteCreatorName'
import { formatPropertyIdentifier } from '../components/helpers/propertyIdentifier'
import Button from '../components/UI/Button'

function CompanyDetailPage() {
  const [company, setCompany] = useState([])
  const [edit, setEdit] = useState(false)
  const [companyType, setCompanyType] = useState("")
  const [tagsList, setTagsList] = useState([])
  const [tags, setTags] = useState([])
  const [expandedSection, setExpandedSection] = useState(null)
  const [notes, setNotes] = useState([])
  const [selectedNote, setSelectedNote] = useState(null)
  const [noteForm, setNoteForm] = useState({ noteDate: dayjs(), noteType: 'Note', subject: '', content: '' })
  const [editingNote, setEditingNote] = useState(null)
  const [contacts, setContacts] = useState([])
  const [contactsList, setContactsList] = useState([])
  const [linkNewContact, setLinkNewContact] = useState(false)
  const [loadingContactLink, setLoadingContactLink] = useState(false)
  const [projects, setProjects] = useState([])
  const [buildings, setBuildings] = useState([])
  const [properties, setProperties] = useState([])
  const [units, setUnits] = useState([])
  const [noteProject, setNoteProject] = useState({})
  const [noteBuilding, setNoteBuilding] = useState({})
  const [noteProperty, setNoteProperty] = useState({})
  const [noteUnit, setNoteUnit] = useState({})
  const [notePopupIsActive, setNotePopupIsActive] = useState(false)
  const [noteDetailPopupIsActive, setNoteDetailPopupIsActive] = useState(false)
  const [selectedCompanyFunctions, setSelectedCompanyFunctions] = useState([])
  const [companyProperties, setCompanyProperties] = useState([])
  const [propertiesTab, setPropertiesTab] = useState("properties") // properties | rentals
  const [rentalContracts, setRentalContracts] = useState([])
  const [loadingRentalContracts, setLoadingRentalContracts] = useState(false)

  const navigate = useNavigate()
  const { companyID } = useParams()

  const formSectionAddressInfo = useRef(null)
  const formSectionShippingInfo = useRef(null)

  const companyFunctions = useSelector(state => state.companiesPage.companyFunctions)

  const fetchCompany = async () => {
    const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/companies/get?companyID=${companyID}`)

    setCompanyType(response.data.company_type)
    setSelectedCompanyFunctions(response.data.company_functions)

    setCompany(response.data)
  }

  const fetchNotes = async () => {
    const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/notes/get/${companyID}?type=company`)
    setNotes(response.data)
  }

  const fetchTagsList = async () => {
    const response = await httpClient.get(import.meta.env.VITE_API_URL + "/api/tags/get")
    setTagsList(response.data)
  }

  const fetchTags = async () => {
    const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/tags/get/${companyID}?type=company`)
    setTags(response.data)
  }

  const fetchLinkedContactsList = async () => {
    const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/contacts/get`)
    setContactsList(response.data)
  }

  const fetchLinkedContacts = async () => {
    const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/company-contacts/get/${companyID}?type=contacts`)
    setContacts(response.data)
  }

  const fetchProjects = async () => {
    const response = await httpClient.get(import.meta.env.VITE_API_URL + "/api/projects/get")
    setProjects(response.data)
  }

  const fetchCompanyProperties = async () => {
    try {
      const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/properties/properties-of-company?companyID=${companyID}`)
      setCompanyProperties(response.data)
    } catch (error) {
      console.error("Error fetching company properties:", error)
      setCompanyProperties([])
    }
  }

  const fetchCompanyRentalContracts = async () => {
    if (!companyID) return
    setLoadingRentalContracts(true)
    try {
      const response = await httpClient.get(import.meta.env.VITE_API_URL + `/api/rental-contracts/of-company?companyID=${companyID}&detailed=true`)
      setRentalContracts(Array.isArray(response.data) ? response.data : [])
    } catch (error) {
      console.error("Error fetching company rental contracts:", error)
      setRentalContracts([])
    } finally {
      setLoadingRentalContracts(false)
    }
  }

  const fetchBuildings = async () => {
    const data = {
      filters: {
        project_id: noteProject?.id,
      }
    }
    const response = await httpClient.post(import.meta.env.VITE_API_URL + "/api/buildings/get", data)
    setBuildings(response.data)
  }

  const fetchUnits = async () => {
    const data = {
      filters: {
        building_id: noteBuilding?.id
      }
    }
    const response = await httpClient.post(import.meta.env.VITE_API_URL + "/api/units/get", data)
    setUnits(response.data)
  }

  useEffect(() => {
    fetchBuildings()
  }, [noteProject])

  useEffect(() => {
    fetchUnits()
  }, [noteBuilding])

  useEffect(() => {
    fetchUnits()
  }, [noteProperty])

  useEffect(() => {
    fetchCompany()
    fetchTagsList()
    fetchTags()
    fetchNotes()
    fetchLinkedContacts()
    fetchLinkedContactsList()
    fetchProjects()
    fetchCompanyProperties()
    fetchCompanyRentalContracts()

    const companyDetails = document.querySelector("#company-details")
    const inputFields = companyDetails.querySelectorAll(".input_field")
    const checkboxes = companyDetails.querySelectorAll(".checkbox__container")
    const dropdowns = companyDetails.querySelectorAll(".dropdown__container-dropdown")

    const formElements = [inputFields, checkboxes, dropdowns]

    formElements.forEach(elementList => {
      if (elementList.length > 0) {
        elementList.forEach(element => {
          element.classList.add("disabled")
        })
      }
    })
  }, [])

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleToggleSection = (sectionId) => {
    if (expandedSection === sectionId) {
      // If the section is already expanded, collapse it
      setExpandedSection(null)
    } else {
      // Expand the selected section
      setExpandedSection(sectionId)
    }
  }

  const handleRentalContractClick = (contractId) => {
    if (!contractId) return
    navigate(`/rental-contracts/${contractId}`)
  }

  const handleEditCompany = async () => {
    if (edit) {
      const editButton = document.querySelector("#companies__btn-edit")
      editButton.disabled = true

      let okToSave = true
      const formData = company

      const emailErrorElement = document.getElementById("input_error_email")
      const email = document.getElementById("company__email")

      formData["company_functions"] = selectedCompanyFunctions
      formData["company_type"] = companyType

      const emailValidation = /\S+@\S+\.\S+/

      if (email.value) {
        if (emailValidation.test(email.value)) {
          email.classList.remove("red-border")
          emailErrorElement.classList.add("hide")
        } else {
          email.classList.add("red-border")
          emailErrorElement.classList.remove("hide")
        }
      }

      if (!okToSave) {
        toast.error("Please complete all fields")
        document.getElementById("companies__btn-edit").disabled = false
        return
      }

      console.log(formData)

      const response = await toast.promise(
        httpClient.put(import.meta.env.VITE_API_URL + `/api/company/update?companyID=${companyID}`, formData),
        {
          pending: "Update company...",
          success: "Company has been update 👍",
          error: "Something went wrong 😢"
        }
      )
      console.log(response.data)

      fetchCompany()

      editButton.disabled = false
      setEdit(!edit)
    } else {
      setEdit(!edit)

      const companyDetails = document.querySelector("#company-details")
      const inputFields = companyDetails.querySelectorAll(".input_field")
      const checkboxes = companyDetails.querySelectorAll(".checkbox__container")
      const dropdowns = companyDetails.querySelectorAll(".dropdown__container-dropdown")

      const formElements = [inputFields, checkboxes, dropdowns]

      formElements.forEach(elementList => {
        if (elementList.length > 0) {
          elementList.forEach(element => {
            element.classList.remove("disabled")
          })
        }
      })
    }
  }

  const setStateTag = async (tagID, type = "add") => {
    if (type == "add") {
      const response = await httpClient.put(import.meta.env.VITE_API_URL + `/api/tags/add/${companyID}?tagID=${tagID}&type=company`)
    }

    if (type == "remove") {
      const response = await httpClient.delete(import.meta.env.VITE_API_URL + `/api/tags/remove/${companyID}?tagID=${tagID}&type=company`)
    }
  }

  const handleCreateNote = () => {
    setEditingNote(null)
    setNoteForm({ noteDate: dayjs(), noteType: 'Note', subject: '', content: '' })
    setNotePopupIsActive(true)
  }

  const handleEditNote = (note) => {
    setEditingNote(note)
    setNoteForm({
      noteDate: parseDateValue(note?.date_note) || dayjs(),
      noteType: note?.type || 'Note',
      subject: note?.subject || '',
      content: note?.note || ''
    })
    setNotePopupIsActive(true)
  }

  const handleSaveNewNote = async () => {
    const { subject, content, noteDate, noteType } = noteForm

    if (editingNote?.id) {
      const data = { subject, content, noteDate, noteType }

      await toast.promise(
        httpClient.put(import.meta.env.VITE_API_URL + `/api/notes/update/${editingNote.id}`, data),
        {
          pending: "Updating note...",
          success: "Note has been updated 👍",
          error: "Something went wrong 😢"
        }
      )

      fetchNotes()
      setEditingNote(null)
      setNoteForm({ noteDate: dayjs(), noteType: 'Note', subject: '', content: '' })
      setNotePopupIsActive(false)
      return
    }

    const data = {
      subject, content, noteDate, noteType, companyID, noteBuilding, noteProject, noteProperty, noteUnit
    }

    const response = await toast.promise(
      httpClient.post(import.meta.env.VITE_API_URL + `/api/notes/add`, data),
      {
        pending: "Creating note...",
        success: "Note has been created 👍",
        error: "Something went wrong 😢"
      }
    )
    console.log(response.data)

    fetchNotes()
    setNoteForm({ noteDate: dayjs(), noteType: 'Note', subject: '', content: '' })
    setNotePopupIsActive(false)
  }

  const handlePropertyClick = (property) => {
    const projectId = property?.project?.id
    const units = Array.isArray(property?.units) ? property.units : []

    if (!projectId) {
      toast.error("No project linked to this property.")
      return
    }

    if (units.length === 0) {
      toast.error("No unit linked to this property.")
      return
    }

    // Default behavior: open the first linked unit
    const u = units[0]
    const unitId = typeof u?.id === 'object' ? u?.id?.id : u?.id
    const buildingId = typeof u?.building_id === 'object' ? u?.building_id?.id : u?.building_id

    if (!unitId || !buildingId) {
      toast.error("Unit link is missing building information.")
      return
    }

    navigate(`/projects/${projectId}/buildings/${buildingId}/units/${unitId}`)
  }

  const handleUnitTagClick = (e, property, unit) => {
    e.stopPropagation()
    const projectId = property?.project?.id
    const unitId = typeof unit?.id === 'object' ? unit?.id?.id : unit?.id
    const buildingId = typeof unit?.building_id === 'object' ? unit?.building_id?.id : unit?.building_id

    if (!projectId || !unitId || !buildingId) {
      toast.error("Cannot navigate to unit: missing link data.")
      return
    }
    navigate(`/projects/${projectId}/buildings/${buildingId}/units/${unitId}`)
  }

  const handleSetSelectedCompanyFunctions = (value, action) => {
    if (action == "add") {
      setSelectedCompanyFunctions(prevArray => [...prevArray, value])
    } else {
      setSelectedCompanyFunctions(prevArray => prevArray.filter(item => item.id !== value.id))
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCompany(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleDeleteCompany = () => {
    if (!companyID) return

    showNotificationPopup({
      message: 'Are you sure you want to delete this company? This action cannot be undone.',
      cancelButton: { text: 'Cancel', color: 'var(--secondairy-light-medium-gray)' },
      actionButton: { text: 'Delete', color: 'var(--red)' },
      onAction: async () => {
        try {
          await toast.promise(
            httpClient.delete(import.meta.env.VITE_API_URL + `/api/company/delete?companyID=${companyID}`),
            {
              pending: 'Deleting company...',
              success: 'Company deleted 👍',
              error: 'Delete failed 😢'
            }
          )
          navigate('/companies')
        } catch (error) {
          const apiMsg = error?.response?.data?.message
          toast.error(apiMsg || 'Cannot delete company. It may have related records.')
        }
      }
    })
  }

  return (
    <div className='template'>

      <Header>
        <div className="back_button" onClick={handleGoBack}><KeyboardBackspaceIcon /> Go Back</div>

        <div className='header__options--right'>
          {/* <button className='options-button-header medium' onClick={handleCreateNote}>create note</button> */}
          <Button variant='primary' size='sm' id="companies__btn-edit" onClick={handleEditCompany}>{edit ? "Save" : "Edit Details"}</Button>
          <Button variant='secondary' tone='red' size='sm' onClick={handleDeleteCompany}>Delete</Button>
        </div>
      </Header>

      <MenuBar />

      <div className="template__body" id='body-company-detail'>

        <PopOutWindow popupID={"popout-company-create-note"} isActive={notePopupIsActive} setIsActive={setNotePopupIsActive}>
          <div className='popout_window__header'>
            <Button variant='primary' size='sm' onClick={handleSaveNewNote}>{editingNote ? 'Update' : 'Save'}</Button>
          </div>

          <div className='form__section' >
            <div className="input_field">
              <label className="input_field__label" htmlFor="note_date">Note date</label>
              <DateField className="date-picker" format="DD-MM-YYYY" value={noteForm.noteDate} onChange={(newValue) => setNoteForm(prev => ({ ...prev, noteDate: newValue }))} />
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="note_type">Note type</label>
              <Dropdown
                index={"note-type"}
                listArray={Object.keys(noteTypes)}
                state={noteForm.noteType}
                setState={(value) => setNoteForm(prev => ({ ...prev, noteType: value }))}
                placeholder={"Select note type"}
                width={"50%"}
                height="40px"
              />
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="note_type">Project</label>
              <DropdownSpecialObject
                index={"note-projects"}
                listArray={projects}
                valueToShow="project_placeholder_name"
                valueToShow2="project_commercial_name"
                state={noteProject}
                setState={setNoteProject}
                placeholder={"Select project"}
                width={"50%"}
                height="40px"
              />
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="note_type">Building</label>
              <DropdownSpecialObject
                index={"note-buildings"}
                listArray={buildings}
                valueToShow="building_name"
                autoSelect={true}
                state={noteBuilding}
                setState={setNoteBuilding}
                placeholder={"Select building"}
                width={"50%"}
                height="40px"
              />
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="note_type">Unit</label>
              <DropdownSpecialObject
                index={"note-unit"}
                listArray={units}
                valueToShow="unit_name"
                autoSelect={true}
                state={noteUnit}
                setState={setNoteUnit}
                placeholder={"Select unit"}
                width={"50%"}
                height="40px"
              />
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="note_subject">Subject</label>
              <input className="input_field__input_box--text" id="note_subject" type="text" name="note_subject" value={noteForm.subject} onChange={(e) => setNoteForm(prev => ({ ...prev, subject: e.currentTarget.value }))} />
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="note_content">Content</label>
              <textarea className="input_field__input_box--text-area" id="note_content" type="text" name="note_content" value={noteForm.content} onChange={(e) => setNoteForm(prev => ({ ...prev, content: e.currentTarget.value }))} />
            </div>

          </div>
        </PopOutWindow>

        <div className={`body__section ${expandedSection === "company-details" ? "full-screen" : ""}`} id="company-details">
          <h2 onClick={() => handleToggleSection("company-details")}>DETAILS</h2>
          <div className="form__section">

            <div className="input_field">
              <label className="input_field__label" htmlFor="company_name">Name</label>
              <input 
                className="input_field__input_box--text" 
                id="company_name" 
                type="text" 
                name="company_name" 
                value={company.company_name || ''} 
                onChange={handleInputChange} 
              />
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="vat_number">VAT number (if VAT registered)</label>
              <input className="input_field__input_box--text" id="vat_number" name="vat_number" value={company.vat_number || ''} onChange={handleInputChange} placeholder="BE0123456789" />
            </div>
            <div className="input_field--combo-5050--grid">
              <div className="input_field">
                <label className="input_field__label" htmlFor="company_number">Company number</label>
                <input 
                  className="input_field__input_box--text" 
                  id="company_number" 
                  type="text" 
                  name="company_number" 
                  value={company.company_number || ''} 
                  onChange={handleInputChange} 
                />
              </div>

              <div className='input_field'>
                <label className="input_field__label" htmlFor="company_type">Company type</label>
                <Dropdown
                  index={"company-type"}
                  listArray={["NV", "BV", "VOF", "CV", "MS", "CommV"]}
                  setState={setCompanyType}
                  state={companyType}
                  placeholder={""}
                  width={"100%"}
                  searchBar={true}
                  margin={"0"}
                  height={"33px"}
                />
              </div>
            </div>

            <div className="input_field">
              <label className="input_field__label" htmlFor="company_functions">Company functions</label>
              <DropdownMultiselect
                index={"company-functions"}
                listArray={companyFunctions}
                state={selectedCompanyFunctions}
                setState={handleSetSelectedCompanyFunctions}
                placeholder={""}
                width={"100%"}
                displayValueKey={"function"}
              />
            </div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="email">Email</label>
            <input 
              className="input_field__input_box--text" 
              id="company__email" 
              type="text" 
              name="email" 
              value={company.email || ''} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="input_error hide" id="input_error_email">I suspect this is not a valid email address 🤖</div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="email">Website</label>
            <input 
              className="input_field__input_box--text" 
              id="company__website" 
              type="text" 
              name="website" 
              value={company.website || ''} 
              onChange={handleInputChange} 
            />
          </div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="phone">Business phone</label>
            <input 
              className="input_field__input_box--text" 
              id="company_phone" 
              type="text" 
              name="phone" 
              value={company.phone || ''} 
              onChange={handleInputChange} 
            />
          </div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="total_amount_of_shares">company shares amount</label>
            <input 
              className="input_field__input_box--text half" 
              id="company_total_shares" 
              type="text" 
              name="total_amount_of_shares" 
              value={company.total_amount_of_shares || ''} 
              onChange={handleInputChange} 
            />
          </div>

        </div>

        <div className="form__section" id="address_info" ref={formSectionAddressInfo}>
          <div className="input_field">
            <label className="input_field__label" htmlFor="address_street">Address</label>
            <input 
              className="input_field__input_box--text" 
              id="company__address" 
              type="text" 
              name="street" 
              value={company.street || ''} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="input_field--combo-3070">
            <div className="input_field">
              <label className="input_field__label" htmlFor="address_pc">Postal code</label>
              <input 
                className="input_field__input_box--text" 
                id="company__address_pc" 
                type="text" 
                name="postal_code" 
                value={company.postal_code || ''} 
                onChange={handleInputChange} 
              />
            </div>
            <div className="input_field">
              <label className="input_field__label" htmlFor="address_place">City</label>
              <input 
                className="input_field__input_box--text" 
                id="company__address_place" 
                type="text" 
                name="city" 
                value={company.city || ''} 
                onChange={handleInputChange} 
              />
            </div>
          </div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="address_province">Province</label>
            <input 
              className="input_field__input_box--text" 
              id="companies__address_place" 
              type="text" 
              name="province" 
              value={company.province || ''} 
              onChange={handleInputChange} 
            />
          </div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="address_nr">Country</label>
            <input 
              className="input_field__input_box--text" 
              id="company__address_country" 
              type="text" 
              name="country" 
              value={company.country || 'Belgium'} 
              onChange={handleInputChange} 
            />
          </div>
        </div>

        <div className="form__section" id="other_info" ref={formSectionShippingInfo}>
          <div className="input_field">
            <label className="input_field__label" htmlFor="address_street">Shipping address</label>
            <input 
              className="input_field__input_box--text" 
              id="company_shipping__address" 
              type="text" 
              name="shipping_street" 
              value={company.shipping_street || ''} 
              onChange={handleInputChange} 
            />
          </div>
          <div className="input_field--combo-3070">
            <div className="input_field">
              <label className="input_field__label" htmlFor="address_pc">Shipping postal code</label>
              <input 
                className="input_field__input_box--text" 
                id="company_shipping__address_pc" 
                type="text" 
                name="shipping_postal_code" 
                value={company.shipping_postal_code || ''} 
                onChange={handleInputChange} 
              />
            </div>
            <div className="input_field">
              <label className="input_field__label" htmlFor="address_place">city</label>
              <input 
                className="input_field__input_box--text" 
                id="company_shipping__address_place" 
                type="text" 
                name="shipping_city" 
                value={company.shipping_city || ''} 
                onChange={handleInputChange} 
              />
            </div>
          </div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="address_province">Shipping province</label>
            <input 
              className="input_field__input_box--text" 
              id="company_shipping__address_place" 
              type="text" 
              name="shipping_province" 
              value={company.shipping_province || ''} 
              onChange={handleInputChange} 
            />
          </div>

          <div className="input_field">
            <label className="input_field__label" htmlFor="address_nr">Country</label>
            <input 
              className="input_field__input_box--text" 
              id="company_shipping__address_country" 
              type="text" 
              name="shipping_country" 
              value={company.shipping_country || 'Belgium'} 
              onChange={handleInputChange} 
            />
          </div>
        </div>

      </div>

      <div className={`body__section ${expandedSection === "company-tags" ? "full-screen" : ""}`} id="company-tags">
        <h2 onClick={() => handleToggleSection("company-tags")}>TAGS</h2>
        <div className="form__section">
          <DropdownMultiselectTags
            state={tags}
            listArray={tagsList}
            setState={setStateTag}
            type="company"
          />
        </div>
      </div>

      <div className={`body__section ${expandedSection === "company-properties" ? "full-screen" : ""}`} id="company-properties">
        <h2 onClick={() => handleToggleSection("company-properties")}>PROPERTIES</h2>
        <div className="form__section">
          <div className="menu__titles properties-subnav">
            <h3
              className={`${propertiesTab === "properties" ? "selected" : ""}`}
              onClick={() => setPropertiesTab("properties")}
            >
              properties
            </h3>
            <h3
              className={`${propertiesTab === "rentals" ? "selected" : ""}`}
              onClick={() => setPropertiesTab("rentals")}
            >
              rental contracts
            </h3>
          </div>

          {propertiesTab === "properties" ? (
            companyProperties.length === 0 ? (
              <div className="no-data-message">
                <p>This company does not own any properties.</p>
              </div>
            ) : (
              companyProperties.map((property, index) => (
                <div
                  key={index}
                  className="property-item"
                  onClick={() => handlePropertyClick(property)}
                >
                  <div className="property-header">
                    <div className="property-item-title">Cadastral Nr: {formatPropertyIdentifier(property.cadastral_nr, property.partition_nr)}</div>
                    {property.project && (
                      <span style={{ fontSize: '0.9em', color: '#666' }}>
                        Project: {property.project.project_placeholder_name || property.project.project_commercial_name}
                      </span>
                    )}
                  </div>

                  {property.units && property.units.length > 0 && (
                    <div className="property-units">
                      <div className="property-item-title">Units:</div>
                      <div className="units-container">
                        {property.units.map((unit, unitIndex) => (
                          <span
                            key={unitIndex}
                            className="unit-tag"
                            onClick={(e) => handleUnitTagClick(e, property, unit)}
                            title="Open unit"
                          >
                            {unit.unit_name}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="property-click-hint">
                    Click to view project details
                  </div>
                </div>
              ))
            )
          ) : (
            loadingRentalContracts ? (
              <LoadingSpinner />
            ) : (
              rentalContracts.length === 0 ? (
                <div className="no-data-message">
                  <p>No rental contracts linked to this company.</p>
                </div>
              ) : (
                rentalContracts.map((c, idx) => {
                  const unitNames = Array.isArray(c.units) ? c.units.map(u => u.unit_name).filter(Boolean) : []
                  const participantTypes = Array.from(new Set(
                    (Array.isArray(c.participants) ? c.participants : [])
                      .filter(p => p?.company?.id == companyID)
                      .map(p => p?.participant_type)
                      .filter(Boolean)
                  ))
                  return (
                    <div
                      key={c.id || idx}
                      className="property-item"
                      onClick={() => handleRentalContractClick(c.id)}
                      title="Open rental contract"
                    >
                      <div className="property-header">
                        <div className="property-item-title">Contract Nr: {c.id}</div>
                        <span style={{ fontSize: '0.9em', color: '#666' }}>
                          {c.rental_type ? `Type: ${c.rental_type}` : "Type: N/A"}{typeof c.active === 'boolean' ? ` • ${c.active ? 'Active' : 'Inactive'}` : ''}
                        </span>
                        <span style={{ fontSize: '0.9em', color: '#666' }}>
                          Role: {participantTypes.length > 0 ? participantTypes.join(', ') : 'N/A'}
                        </span>
                      </div>

                      <div className="property-units">
                        <div className="property-item-title">Units:</div>
                        <div className="units-container">
                          {unitNames.length === 0 ? (
                            <span style={{ fontSize: '0.85em', color: '#999' }}>No units linked</span>
                          ) : (
                            unitNames.map((name, i) => (
                              <span key={i} className="unit-tag">{name}</span>
                            ))
                          )}
                        </div>
                      </div>

                      <div className="property-click-hint">
                        {c.start_date ? `Start: ${formatDate(c.start_date)}` : "Start: N/A"}{c.end_date ? ` • End: ${formatDate(c.end_date)}` : ""}
                      </div>
                    </div>
                  )
                })
              )
            )
          )}
        </div>
      </div>

      <div className={`body__section ${expandedSection === "company-notes" ? "full-screen" : ""}`} id="company-notes">
        <PopupWindow popupID={"popup-company-notes"} isActive={noteDetailPopupIsActive} setIsActive={setNoteDetailPopupIsActive}>
          {
            selectedNote != null &&
            <div className='note__container--popup note__container--popup--detail'>
              <div className='date_note--popup'>
                <div className='popup_window__subtitle'>Date:</div>
                <p>{formatDate(selectedNote.date_note)}</p>
              </div>
                <div className='date_note--popup'>
                  <div className='popup_window__subtitle'>Created by:</div>
                <p>{getNoteCreatorName(selectedNote)}</p>
                </div>
              <div className='date_note--popup'>
                <div className='popup_window__subtitle'>Subject:</div>
                <p>{selectedNote.subject}</p>
              </div>
              <div className='note_text--popup'>
                <div className='popup_window__subtitle'>Note:</div>
                <p>{selectedNote.note}</p>
              </div>
            </div>
          }
        </PopupWindow>

        <h2 onClick={() => handleToggleSection("company-notes")}>NOTES</h2>
        <div className="form__section">
          <button className='more--btn' onClick={handleCreateNote}>+</button>

          {
            notes.map((note, index) => {
              return (
                <Note
                  popupWindowID="popup-company-notes"
                  key={index}
                  noteObj={note}
                  type={note.type}
                  note={note.note}
                  subject={note.subject}
                  date={note.date_note}
                  setSelectedNote={setSelectedNote}
                  setPopupActive={setNoteDetailPopupIsActive}
                  onEdit={handleEditNote}
                />
              )
            })
          }
        </div>
      </div>

      <div className={`body__section ${expandedSection === "company-contacts" ? "full-screen" : ""}`} id="company-contacts">

        <h2 onClick={() => handleToggleSection("company-contacts")}>CONTACTS</h2>
        <div className="form__section">
          {
            linkNewContact ?
              loadingContactLink ?
                <div className='flex' style={{ gap: "15px", marginTop: "10px" }}>
                  <div className='skeleton-loader' style={{ height: "30px", width: "100%" }}></div>
                  <div className='skeleton-loader' style={{ height: "30px", width: "50%" }}></div>
                </div> :
                <AddContactToCompany
                  contactsList={contactsList}
                  contactState={""}
                  contactFunctionState={""}
                  setLoading={setLoadingContactLink}
                  companyID={companyID}
                  refreshData={fetchLinkedContacts}
                  setLinkNewContact={setLinkNewContact}
                  maxHeightUL={expandedSection == "contact-companies" ? "350px" : "150px"}
                /> :
              <button className='more--btn' onClick={() => setLinkNewContact(true)}>+</button>
          }
          {
            contacts.map((contact, index) => {
              return (
                <AddContactToCompany
                  key={index}
                  contactsList={contactsList}
                  contactState={`${contact.contact_id.first_name} ${contact.contact_id.last_name}`}
                  contactIDState={contact.contact_id.id}
                  contactFunctionState={contact.function}
                  companyID={companyID}
                  refreshData={fetchLinkedContacts}
                  disabled={true}
                />
              )
            })
          }

        </div>
      </div>


    </div>

    </div >
  )
}

export default CompanyDetailPage
